import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'RealTalk', href: '/realtalk' },
    { name: 'App Reviews', href: '/reviews' },
    { name: 'Mining Tools', href: '/mining' },
    { name: 'Meine Taktik', href: '/taktik' },
    { name: 'Blog', href: '/blog' },
    { name: 'Über uns', href: '/about' },
    { name: 'Kontakt', href: '/contact' }
  ];

  const handleExploreApps = () => {
    navigate('/reviews');
  };

  return (
    <header className="bg-gray-900/95 backdrop-blur-sm border-b border-gray-800 sticky top-0 z-50">
      <nav className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-shield-check-line text-2xl text-teal-400"></i>
            </div>
            <span className="text-xl font-bold text-white">EarnProof</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors duration-200 ${
                  location.pathname === item.href
                    ? 'text-teal-400'
                    : 'text-gray-300 hover:text-teal-400'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Button variant="primary" size="sm" onClick={handleExploreApps}>
              Apps entdecken
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-300 hover:text-white p-2"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-800">
            <div className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`text-sm font-medium transition-colors duration-200 ${
                    location.pathname === item.href
                      ? 'text-teal-400'
                      : 'text-gray-300 hover:text-teal-400'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Button variant="primary" size="sm" className="w-fit" onClick={handleExploreApps}>
                Apps entdecken
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
